import OrganizationSettings from '@/components/organization/OrganizationSettings'
import ExpensesSettings from '@/components/organization/ExpensesSettings'
import CustomFields from '@/components/organization/CustomFields'

export default [
  {
    path: '/organization/settings',
    name: 'organization-settings',
    component: OrganizationSettings,
    meta: { title: 'Organization Settings', permission: 'organization' }
  },
  {
    path: '/organization/expenses',
    name: 'organization-expenses',
    component: ExpensesSettings,
    meta: { title: 'Expenses', permission: 'organization' }
  },
  {
    path: '/organization/custom-fields',
    component: CustomFields,
    name: 'organization-fields',
    meta: { title: 'Custom Fields', permission: 'organization' }
  }
]
